import {createSelector} from 'reselect';

export const holidayCalendarStateSelector = state => state.holidayCalendar;

export const holidayCalendarSelector = createSelector(holidayCalendarStateSelector, item => {
  let retVal = null;
  if (item.success) retVal = item?.template ? item.template : {};
  return retVal;
});
